import type { ReactNode } from 'react';
import styles from './index.module.scss';

/**
 * Dashboard レイアウトのコンテンツ部分を提供するコンポーネント
 * メイン領域とフッター領域の共通構造を定義します
 */
type Props = {
  /** メイン領域に表示する子要素 */
  children: ReactNode;
  /** フッターに表示するリンク要素（オプション） */
  footerLinks?: ReactNode;
  /** 著作権表示に使用する会社名（オプション） */
  copyrightCompanyName?: string;
  /** パートナーヘッダーを表示しているかどうか */
  visiblePartnerHeader?: boolean;
};

/**
 * Dashboard レイアウトのコンテンツ部分
 *
 * @param props - Props
 * @returns JSX.Element
 */
export const DashboardContent: React.FC<Props> = ({
  children,
  footerLinks,
  copyrightCompanyName,
  visiblePartnerHeader = false,
}) => {
  return (
    <div className={styles.DashboardContent}>
      <main
        className={`${styles.DashboardContent__Main} ${visiblePartnerHeader && styles.DashboardContent__Main__WithHeader}`}
      >
        {children}
      </main>

      <footer className={styles.DashboardContent__Footer}>
        {footerLinks && <div className={styles.DashboardContent__Links}>{footerLinks}</div>}
        <div className={styles.DashboardContent__Copyright}>
          {copyrightCompanyName && `©️${copyrightCompanyName} All Rights Reserved.`}
        </div>
      </footer>
    </div>
  );
};
